<script>
    import { mapActions, mapGetters, mapState } from "vuex";
    import { sendAnalytics } from "@/core/SendAnalytics";
    import { lazyLoad } from "@/utils";
    import ProductCard from "@igarden/components/ProductCard";

    export default {
        name: "HomeCatalog",
        components: {
            ProductCard,
        },
        watch: {
            catalog: {
                handler(products) {
                    if (process.env.VUE_APP_ENV === "client" && Object.keys(products).length) {
                        sendAnalytics.send(sendAnalytics.events.productList, products);
                    }
                    this.$nextTick(() => {
                        lazyLoad();
                    });
                },
                immediate: true,
            },
        },
        computed: {
            ...mapState("Root", ["catalog", "isLoadingCatalog"]),
            ...mapGetters("Root", ["productsInCartIds"]),
        },
        serverPrefetch() {
            return this.getCatalog();
        },
        mounted() {
            if (!this.catalog.length) {
                this.getCatalog();
            }
        },
        methods: {
            ...mapActions("Root", ["getCatalog"]),
        },
    };
</script>

<template>
    <div class="home-catalog">
        <h1 id="catalog" class="home-page__title page-title">Каталог</h1>

        <preloader v-show="isLoadingCatalog" lg-size></preloader>
        <div class="home-catalog__wrapper" :class="{ 'is-loading': isLoadingCatalog }">
            <div class="home-catalog__card" v-for="(product, i) in catalog" :key="product.id">
                <product-card
                    :product="product"
                    :position="i"
                    :is-odd="Boolean((i + 1) % 2)"
                    :in-cart-list="productsInCartIds"
                ></product-card>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .home-catalog {
        position: relative;

        & > .global-preloader {
            top: 200px;
            bottom: auto;
        }
    }

    .home-catalog__wrapper {
        display: flex;
        flex-wrap: wrap;
        min-height: 440px;
        margin: 0 -4px -8px;
        transition: 0.3s ease-in-out opacity;
        &.is-loading {
            opacity: 0.3;
        }

        @include bp($bp-desktop-sm) {
            margin: 0 -12px -24px;
        }
    }

    .home-catalog__card {
        width: 50%;
        margin-bottom: 8px;
        padding: 0 4px 8px;
        @include bp($bp-desktop-sm) {
            width: 33.33334%;
            margin-bottom: 24px;
            padding: 0 12px;
        }
        @include bp($bp-desktop-md) {
            width: 25%;
        }
    }
</style>
